import React from "react";
import { SiFigma, SiPython, SiMysql, SiFirebase, SiAmazonwebservices, SiGnubash, SiJavascript, SiReact, SiSwift, SiNodedotjs, SiHtml5, SiCss3, SiLinux } from "react-icons/si";
import styles from "../assets/styles/NewSkills.module.css";
import { motion } from "framer-motion";
import wavesdown from "../assets/images/wavesdown.svg"
import wavesup from "../assets/images/wavesup.svg"

const skills = [
  { name: "Figma", icon: <SiFigma color="#F24E1E" size={32} /> },
  { name: "Python", icon: <SiPython color="#3776AB" size={32} /> },
  { name: "SQL", icon: <SiMysql color="#00618A" size={32} /> },
  { name: "Firebase", icon: <SiFirebase color="#FFCA28" size={32} /> },
  { name: "AWS", icon: <SiAmazonwebservices color="#FF9900" size={32} /> },
  { name: "Bash", icon: <SiGnubash color="#4EAA25" size={32} /> },
  { name: "HTML", icon: <SiHtml5 color="#E34F26" size={32} /> },
  { name: "CSS", icon: <SiCss3 color="#1572B6" size={32} /> },
  { name: "JavaScript", icon: <SiJavascript color="#F7DF1E" size={32} /> },
  { name: "React", icon: <SiReact color="#61DAFB" size={32} /> },
  { name: "Swift", icon: <SiSwift color="#FA7343" size={32} /> },
  { name: "Node.js", icon: <SiNodedotjs color="#339933" size={32} /> },
  { name: "Linux", icon: <SiLinux color="#FCC624" size={32} /> },
];
export default function NewSkills() {
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12, // delay between each card
        delayChildren: 0.2,    // wait a bit before starting
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40, scale: 0.9 },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20,
      },
    },
  };

  return (
    <div className={styles.main}>
      <img className={styles.upperImg} src={wavesup} />
      <div className={styles.skillsSection}>
        <h2 className={styles.title}>Skills</h2>

        <motion.div
  className={styles.grid}
  variants={containerVariants}
  initial="hidden"
  whileInView="show"
  viewport={{ once: true, amount: 0.2 }} // <-- controls trigger point
>
          {skills.map((skill, i) => (
            <motion.div
              key={i}
              className={styles.card}
              variants={cardVariants}
            >
              {skill.icon}
              <p>{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
      <img className={styles.lowerImg} src={wavesdown} />
    </div>
  );
}
// export default function NewSkills() {
//   return (
//     <div className={styles.main}>
//             <img className={styles.upperImg} src={wavesup}/>
//     <div className={styles.skillsSection}>

//       <h2 className={styles.title}>Skills</h2>
//       <div className={styles.grid}>
//         {skills.map((skill, i) => (
//   <motion.div
//     key={i}
//     className={styles.card}
//     initial={{ opacity: 0, y: 20 }}
//     animate={{ opacity: 1, y: 0 }}
//     transition={{ delay: i * 0.1 + 0.2, duration: 0.5 }}
//   >
//     {skill.icon}
//     <p>{skill.name}</p>
//   </motion.div>
// ))}
//       </div>
//     </div>
//     <img className={styles.lowerImg} src={wavesdown}/>
//     </div>
//   );
// }

const aboutPoints = [
  "Started at ALX, building a solid foundation in software engineering.",
  "Professional QA background: experienced in testing, debugging, and ensuring software quality.",
  "Full Stack Developer: skilled with React, Node.js, Swift, Firebase, and AWS.",
  "UI/UX Designer: creating intuitive, modern, and visually appealing interfaces.",
  "Passionate about building creative digital products that solve real problems.",
  "Always learning: continuously improving skills and exploring new technologies.",
];

export const AboutMeSection = () => {
  return (
    <div className={styles.aboutSection}>
      <h2 className={styles.title}>About Me</h2>
      <p className={styles.subtitle}>
        From QA expertise to full-stack development, I combine design, logic, and problem-solving.
      </p>
      <div className={styles.points}>
        {aboutPoints.map((point, index) => (
          <motion.div
            key={index}
            className={styles.pointCard}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
          >
            {point}
          </motion.div>
        ))}
      </div>
    </div>
  );
};